import { render, staticRenderFns } from "./SDIStrategyCard.vue?vue&type=template&id=0571d528&scoped=true"
import script from "./SDIStrategyCard.vue?vue&type=script&lang=js"
export * from "./SDIStrategyCard.vue?vue&type=script&lang=js"
import style0 from "./SDIStrategyCard.vue?vue&type=style&index=0&id=0571d528&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571d528",
  null
  
)

export default component.exports